import { INVITE_OPEN_MODAL, INVITE_CLOSE_MODAL } from '../actions/invite';

import api from '../api';

const INVITES_VERIFY_SUCCESS = api.events.invitesVerify.actionSuccess;
const INVITES_VERIFY_FAILURE = api.events.invitesVerify.actionFail;
const INVITES_VERIFY_RESET = api.events.invitesVerify.actionReset;

const INVITES_CREATE_FETCH = api.events.invitesCreate.actionFetch;
const INVITES_CREATE_SUCCESS = api.events.invitesCreate.actionSuccess;
const INVITES_CREATE_FAILURE = api.events.invitesCreate.actionFail;
const INVITES_CREATE_RESET = api.events.invitesCreate.actionReset;

const defaultState = {
  token: '',
  email: '',
  hasInvite: false,
  isInvalid: false,
  isEmailDuplicateMessageVisible: false,
  isResearchIdDuplicateMessageVisible: false,
  isSuccessMessageVisible: false,
  isInviteModalOpen: false,
  isFetching: false,
  isExpired: false
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case INVITE_OPEN_MODAL: {
      return {
        ...state,
        isInviteModalOpen: true,
        isSuccessMessageVisible: false,
        isEmailDuplicateMessageVisible: false,
        isResearchIdDuplicateMessageVisible: false
      };
    }

    case INVITE_CLOSE_MODAL: {
      return {
        ...state,
        isInviteModalOpen: false,
        isSuccessMessageVisible: false,
        isEmailDuplicateMessageVisible: false,
        isResearchIdDuplicateMessageVisible: false
      };
    }

    case INVITES_VERIFY_SUCCESS: {
      const { token, email } = action.data;
      return { ...state, token, email, hasInvite: true };
    }

    case INVITES_VERIFY_FAILURE: {
      if (action.error && action.error.message === 'INVITE_EXPIRED') {
        return { ...state, isInvalid: true, isExpired: true };
      }
      return { ...state, isInvalid: true };
    }

    case INVITES_VERIFY_RESET: {
      return defaultState;
    }

    case INVITES_CREATE_FETCH: {
      return {
        ...state,
        isEmailDuplicateMessageVisible: false,
        isResearchIdDuplicateMessageVisible: false,
        isFetching: true
      };
    }

    case INVITES_CREATE_SUCCESS: {
      return {
        ...state,
        isSuccessMessageVisible: true,
        isEmailDuplicateMessageVisible: false,
        isResearchIdDuplicateMessageVisible: false,
        isFetching: false
      };
    }

    case INVITES_CREATE_FAILURE: {
      const { type } = action.error.message;
      return {
        ...state,
        isEmailDuplicateMessageVisible: type === 'duplicate-email',
        isResearchIdDuplicateMessageVisible: type === 'duplicate-id',
        isFetching: false
      };
    }

    case INVITES_CREATE_RESET: {
      return {
        ...state,
        isSuccessMessageVisible: false,
        isFetching: false
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/invites.js